import i18next from '../../i18n';

export interface IState {
  abbreviation: string;
  name: string;
}

function getUsStates(): IState[] {
  return [
    {
      abbreviation: 'AL',
      name: i18next.t('alabama'),
    },
    {
      abbreviation: 'AK',
      name: i18next.t('alaska'),
    },
    {
      abbreviation: 'AZ',
      name: i18next.t('arizona'),
    },
    {
      abbreviation: 'AR',
      name: i18next.t('arkansas'),
    },
    {
      abbreviation: 'CA',
      name: i18next.t('california'),
    },
    {
      abbreviation: 'CO',
      name: i18next.t('colorado'),
    },
    {
      abbreviation: 'CT',
      name: i18next.t('connecticut'),
    },
    {
      abbreviation: 'DE',
      name: i18next.t('delaware'),
    },
    {
      abbreviation: 'DC',
      name: i18next.t('district_of_columbia'),
    },
    {
      abbreviation: 'FL',
      name: i18next.t('florida'),
    },
    {
      abbreviation: 'GA',
      name: i18next.t('georgia'),
    },
    {
      abbreviation: 'HI',
      name: i18next.t('hawaii'),
    },
    {
      abbreviation: 'ID',
      name: i18next.t('idaho'),
    },
    {
      abbreviation: 'IL',
      name: i18next.t('illinois'),
    },
    {
      abbreviation: 'IN',
      name: i18next.t('indiana'),
    },
    {
      abbreviation: 'IA',
      name: i18next.t('iowa'),
    },
    {
      abbreviation: 'KS',
      name: i18next.t('kansas'),
    },
    {
      abbreviation: 'KY',
      name: i18next.t('kentucky'),
    },
    {
      abbreviation: 'LA',
      name: i18next.t('louisiana'),
    },
    {
      abbreviation: 'ME',
      name: i18next.t('maine'),
    },
    {
      abbreviation: 'MD',
      name: i18next.t('maryland'),
    },
    {
      abbreviation: 'MA',
      name: i18next.t('massachusetts'),
    },
    {
      abbreviation: 'MI',
      name: i18next.t('michigan'),
    },
    {
      abbreviation: 'MN',
      name: i18next.t('minnesota'),
    },
    {
      abbreviation: 'MS',
      name: i18next.t('mississippi'),
    },
    {
      abbreviation: 'MO',
      name: i18next.t('missouri'),
    },
    {
      abbreviation: 'MT',
      name: i18next.t('montana'),
    },
    {
      abbreviation: 'NE',
      name: i18next.t('nebraska'),
    },
    {
      abbreviation: 'NV',
      name: i18next.t('nevada'),
    },
    {
      abbreviation: 'NH',
      name: i18next.t('new_hampshire'),
    },
    {
      abbreviation: 'NJ',
      name: i18next.t('new_jersey'),
    },
    {
      abbreviation: 'NM',
      name: i18next.t('new_mexico'),
    },
    {
      abbreviation: 'NY',
      name: i18next.t('new_york'),
    },
    {
      abbreviation: 'NC',
      name: i18next.t('north_carolina'),
    },
    {
      abbreviation: 'ND',
      name: i18next.t('north_dakota'),
    },
    {
      abbreviation: 'OH',
      name: i18next.t('ohio'),
    },
    {
      abbreviation: 'OK',
      name: i18next.t('oklahoma'),
    },
    {
      abbreviation: 'OR',
      name: i18next.t('oregon'),
    },
    {
      abbreviation: 'PA',
      name: i18next.t('pennsylvania'),
    },
    {
      abbreviation: 'PR',
      name: i18next.t('puerto_rico'),
    },
    {
      abbreviation: 'RI',
      name: i18next.t('rhode_island'),
    },
    {
      abbreviation: 'SC',
      name: i18next.t('south_carolina'),
    },
    {
      abbreviation: 'SD',
      name: i18next.t('south_dakota'),
    },
    {
      abbreviation: 'TN',
      name: i18next.t('tennessee'),
    },
    {
      abbreviation: 'TX',
      name: i18next.t('texas'),
    },
    {
      abbreviation: 'UT',
      name: i18next.t('utah'),
    },
    {
      abbreviation: 'VI',
      name: i18next.t('virgin_islands'),
    },
    {
      abbreviation: 'VT',
      name: i18next.t('vermont'),
    },
    {
      abbreviation: 'VA',
      name: i18next.t('virginia'),
    },
    {
      abbreviation: 'WA',
      name: i18next.t('washington'),
    },
    {
      abbreviation: 'WV',
      name: i18next.t('west_virginia'),
    },
    {
      abbreviation: 'WI',
      name: i18next.t('wisconsin'),
    },
    {
      abbreviation: 'WY',
      name: i18next.t('wyoming'),
    },
  ];
}

function getCaProvinces(): IState[] {
  return [
    {
      name: i18next.t('alberta'),
      abbreviation: 'AB',
    },
    {
      name: i18next.t('british_columbia'),
      abbreviation: 'BC',
    },
    {
      name: i18next.t('manitoba'),
      abbreviation: 'MB',
    },
    {
      name: i18next.t('new_brunswick'),
      abbreviation: 'NB',
    },
    {
      name: i18next.t('newfoundland_and_labrador'),
      abbreviation: 'NL',
    },
    {
      name: i18next.t('northwest_territories'),
      abbreviation: 'NT',
    },
    {
      name: i18next.t('nova_scotia'),
      abbreviation: 'NS',
    },
    {
      name: i18next.t('nunavut'),
      abbreviation: 'NU',
    },
    {
      name: i18next.t('ontario'),
      abbreviation: 'ON',
    },
    {
      name: i18next.t('prince_edward_island'),
      abbreviation: 'PE',
    },
    {
      name: i18next.t('quebec'),
      abbreviation: 'QC',
    },
    {
      name: i18next.t('saskatchewan'),
      abbreviation: 'SK',
    },
    {
      name: i18next.t('yukon'),
      abbreviation: 'YT',
    },
  ];
}

export default getUsStates;
export { getCaProvinces as caProvinces };
